import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-main-content-wrapper',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './main-content-wrapper.component.html',
    styleUrl: './main-content-wrapper.component.css'
})
export class MainContentWrapperComponent implements AfterViewInit {
    @Input() autoFocus = false;
    @ViewChild('mainContentWrapper', { static: true }) contentRef!: ElementRef<HTMLElement>;

    ngAfterViewInit(): void {
        if (this.autoFocus) {
            const el = this.contentRef.nativeElement;
            el.focus();
        }
    }
}
